/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingHoldersConfig } from '../../config/loading.config';
export interface ILoadingHoldersPluginMethods extends IPluginMethodMap {
  getLoadingHoldersSync(args?: any): any;
}

export class LoadingHoldersPlugin implements IAgentPlugin {
  readonly methods: ILoadingHoldersPluginMethods;

  constructor() {
    this.methods = {
      getLoadingHoldersSync: this.getLoadingHoldersSync.bind(this),
    };
  }

  getLoadingHoldersSync(args?: any) {
    return {
      loading: loadingHoldersConfig,
    };
  }
}
